import type { MessageSlot } from "../widget-config";
import { localSlotIdOfThreadKey, localSlotKeyId, splitLocalKeyId } from "./local-slots";
import { slotIdOfThreadKey, variantIdOfThreadKey } from "./slot-thread";

/**
 * In a `message:<slotId>:<variantId>` thread the header IS that variant (the BE seeded its text), so
 * the slot is narrowed to it with its audience rule dropped (like a frozen local header). Other keys,
 * and a variant that left the slot, return `slots` untouched (same reference).
 */
export function pinThreadVariant(
  slots: readonly MessageSlot[],
  threadKey: string | null | undefined,
): readonly MessageSlot[] {
  const local = localSlotIdOfThreadKey(threadKey);
  const { slotKeyId, variantKeyId } = local
    ? splitLocalKeyId(local)
    : {
        slotKeyId: slotIdOfThreadKey(threadKey),
        variantKeyId: variantIdOfThreadKey(threadKey),
      };
  if (!slotKeyId || !variantKeyId) return slots;
  // Local keys are sanitised (`localSlotKeyId`); BE keys carry the raw ids (same for plain ids).
  const norm = local ? localSlotKeyId : (x: string) => x;
  const slot = slots.find((s) => s.kind === "MESSAGE" && norm(s.id) === slotKeyId);
  const variant = slot?.variants.find((v) => norm(v.id) === variantKeyId);
  if (!slot || !variant) return slots;
  const { when: _when, ...pinned } = variant;
  return slots.map((s) => (s === slot ? { ...s, variants: [pinned] } : s));
}
